"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentWindowForDailyReset = void 0;
const types_1 = require("@fluent-forever/types");
const luxon_1 = require("luxon");
const RESET_HOURS = 3;
const getCurrentWindowForDailyReset = (localTime) => {
    if (!types_1.isIsoDateString(localTime, true)) {
        throw new Error(`${localTime} is not a valid ISO date string`);
    }
    const localDate = luxon_1.DateTime.fromISO(localTime);
    const sameDayAtResetTime = localDate.set({
        hour: RESET_HOURS,
        millisecond: 0,
        minute: 0,
        second: 0,
    });
    if (sameDayAtResetTime < localDate) {
        return {
            from: sameDayAtResetTime.toISO(),
            isBeforeDailyWindowStart: false,
            to: sameDayAtResetTime.plus({ day: 1 }).toISO(),
        };
    }
    else {
        return {
            from: sameDayAtResetTime.minus({ day: 1 }).toISO(),
            isBeforeDailyWindowStart: true,
            to: sameDayAtResetTime.toISO(),
        };
    }
};
exports.getCurrentWindowForDailyReset = getCurrentWindowForDailyReset;
//# sourceMappingURL=daily_reset_utils.js.map